import api from '../tracker/trackerAPI'

export const sendInvitation = (mailList) => (dispatch) => {
	dispatch(setShareStatus('processing'))

	api
		.postInvitationList(mailList)
		.then(() => {
			dispatch(setShareStatus('success'))

			setTimeout(() => {
				dispatch(setShareStatus('pending'))
			}, 3000)
			dispatch(addSentInvitation(mailList))
		})
		.catch(() => {
			dispatch(setShareStatus('error'))
		})
}

export const setSharesLeft = (payload) => ({
	type: 'SET_SHARES_LEFT',
	payload: payload
})

export const setShareStatus = (payload) => ({
	type: 'SET_SHARE_STATUS',
	payload: payload
})

export const addSentInvitation = (mailList) => ({
	type: 'ADD_SENT_INVIT',
	payload: [...mailList]
})
